<template>
    <div class="section-stream-embed" :class="color" v-if="stream">
        <LayoutContained :class="padding">
            <div class="lg:grid lg:grid-cols-4">
                <div class="lg:col-span-3">
                    <EmbedLive
                        v-if="stream.stream_playback_url"
                        :playbackUrl="stream.stream_playback_url"
                        @play="onStreamPlay"
                        @progress="onStreamProgress"
                        @pause="onStreamPause"
                        @destroy="onStreamDestroy"
                    ></EmbedLive>
                    <ImageOptimized v-else class="w-full aspect-video" :src="stream.stream_image_url" alt />
                </div>
                <LayoutLiveChat
                    class="lg:col-span-1"
                    v-if="stream.stream_playback_url && getStreamChatToken(stream.stream_slug)"
                    :token="getStreamChatToken(stream.stream_slug)"
                    :streamSlug="stream.stream_slug"
                    :connected="connected"
                    :messages="messages"
                    :message="message"
                    :initChat="initChat"
                    :updateMessageField="updateMessageField"
                    :sendMessage="sendMessage"
                ></LayoutLiveChat>
            </div>
            <slot name="custom"></slot>
        </LayoutContained>
    </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';

export default {
    name: 'SectionStreamEmbed',
    props: {
        stream: {
            required: false,
            type: Object,
            default () {
                return {};
            },
        },
        padding: {
            required: false,
            default: 'py-5 sm:py-11',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-800',
        },
    },
    computed: {
        ...mapState(useStoreStreams, {
            getStreamChatToken: 'getStreamChatToken',
        }),
        ...mapState(useStoreStreamChat, {
            messages: 'messages',
            message: 'message',
            connected: 'connected'
        }),
    },
    methods: {
        ...mapActions(useStoreStreamChat, {
            initChat: 'initChat',
            updateMessageField: 'updateMessageField',
            sendMessage: 'sendMessage',
        }),
        patchStream (event) {
            if (!this.stream) return;
            useEntityStream().patch(this.stream.stream_slug, {
                id_stream_play: this.stream.id_stream_play,
                stream_play_total_time: (event.totalTime * 1000).toFixed(0),
                stream_play_current_time: (event.currentTime * 1000).toFixed(0),
            });
        },
        onStreamPlay (event) {
            if (this.$config.public.stage === 'dev') console.log('Stream play:', event);
            this.patchStream(event);
        },
        onStreamProgress (event) {
            // if (this.$config.public.stage === 'dev') console.log('Stream progress:', event);
            if (event.totalTime % 5 === 0) this.patchStream(event);
        },
        onStreamPause (event) {
            if (this.$config.public.stage === 'dev') console.log('Stream pause:', event);
            this.patchStream(event);
        },
        onStreamDestroy (event) {
            if (this.$config.public.stage === 'dev') console.log('Stream destroy:', event);
            if (!event.paused) {
                this.patchStream(event);
            }
            this.$emit('refresh');
        },
    },
};
</script>
